import { render, staticRenderFns } from "./VoucherTypeDetails.vue?vue&type=template&id=43decbd5&scoped=true"
import script from "./VoucherTypeDetails.vue?vue&type=script&lang=js"
export * from "./VoucherTypeDetails.vue?vue&type=script&lang=js"
import style0 from "./VoucherTypeDetails.vue?vue&type=style&index=0&id=43decbd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43decbd5",
  null
  
)

export default component.exports